import { Layout, Spin } from 'antd'
import { Content } from 'antd/es/layout/layout'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import s from './MainLayout.module.css'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

function MainLayout() {
  return (
    <Layout className={s.container}>
      <Header />
      <Layout>
        <Content className={s.content}>
          <Suspense
            fallback={
              <Spin
                style={{ margin: '0 auto' }}
                indicator={<LoadingOutlined style={{ color: 'var(--accent-light)' }} />}
              />
            }
          >
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
      <Footer />
    </Layout>
  )
}

export default MainLayout
